import {useTheme} from 'styled-components';
import styles from './styles.module.css';
import cn from 'clsx';

type Props = {
  title: string;
  subTitle: string;
};

function ViewMainInfo({title, subTitle}: Props) {
  const theme = useTheme();
  const color = theme.hasTemplate ? theme.colors.branding.fontPrimary : theme.colors.$p10;
  return (
    <>
      <div className={cn(styles.titleWrapper, 'view-main-info__title')} style={{color}}>
        {title}
      </div>
      <div
        className={cn(styles.subTitleWrapper, 'view-main-info__sub-title')}
        style={{color}}
      >
        {subTitle}
      </div>
    </>
  );
}

export {ViewMainInfo};
